export default __webpack_public_path__ + "static/media/2CDN1JD-min.2a914133.jpg";